import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { submitKeywordDetails } from "../../../../../api/Api";
import { getFromLocalStorage } from "../../../../../utils/common-utils";

const EditKeyword = ({ editData, onUpdate }) => {
  const [keywordData, setKeywordData] = useState({
    subKeywordStatus: "No",
    unSubKeywordStatus: "No",
    infoKeywordStatus: "No",
    moForwardStatus: "No",
    subKeyword: "",
    unsubKeyword: "",
    subArabicKeyword: "",
    unsubArabicKeyword: "",
    infoKeyword: "",
    infoArabicKeyword: "",
    shortCode: "",
    moForwardUrl: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    if (editData) {
      setKeywordData(prev => ({
        ...prev,
        ...editData
      }));
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setKeywordData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setKeywordData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const errors = [];

    if (!keywordData.shortCode) {
      errors.push("ShortCode is required");
    }

    if (keywordData.subKeywordStatus === "Yes") {
      if (!keywordData.subKeyword) errors.push("Subscription Keyword is required");
      if (!keywordData.subArabicKeyword) errors.push("Subscription Arabic Keyword is required");
    }

    if (keywordData.unSubKeywordStatus === "Yes") {
      if (!keywordData.unsubKeyword) errors.push("UnSubscription Keyword is required");
      if (!keywordData.unsubArabicKeyword) errors.push("UnSubscription Arabic Keyword is required");
    }

    if (keywordData.infoKeywordStatus === "Yes") {
      if (!keywordData.infoKeyword) errors.push("Info Keyword is required");
      if (!keywordData.infoArabicKeyword) errors.push("Info Arabic Keyword is required");
    }

    if (keywordData.moForwardStatus === "Yes" && !keywordData.moForwardUrl) {
      errors.push("Mo Forward URL is required");
    }

    if (errors.length > 0) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        html: errors.join("<br>"),
      });
      return;
    }

    try {
      const payload = {
        userId: getFromLocalStorage("userData")?.id,
        id: editData?.id,
        subKeyword: keywordData.subKeyword,
        unsubKeyword: keywordData.unsubKeyword,
        subArabicKeyword: keywordData.subArabicKeyword,
        unsubArabicKeyword: keywordData.unsubArabicKeyword,
        infoKeyword: keywordData.infoKeyword,
        infoArabicKeyword: keywordData.infoArabicKeyword,
        shortCode: keywordData.shortCode,
        subKeywordStatus: keywordData.subKeywordStatus,
        unSubKeywordStatus: keywordData.unSubKeywordStatus,
        infoKeywordStatus: keywordData.infoKeywordStatus,
        moForwardStatus: keywordData.moForwardStatus,
        moForwardUrl: keywordData.moForwardUrl,
      };

      const response = await submitKeywordDetails(payload);

      if (response?.statusDescription?.status === 200) {
        onUpdate(response.productModel);
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description || "Keyword details updated successfully!",
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response?.statusDescription?.description || "Failed to update keyword details",
        });
      }
    } catch (error) {
      console.error("Error updating keyword details:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to update keyword details",
      });
    }
  };

  return (
    <div className="tab-content-section">
      {/* <div className="tab-content"> */}
        <div className="tab-pane active">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="form-group col-md-4">
                <div className="form-group">
                  <label>Sub Keyword<span className="text-danger">*</span></label>
                  <div className="d-flex align-items-center mb-2">
                    <input
                      type="radio"
                      name="subKeywordStatus"
                      value="Yes"
                      checked={keywordData.subKeywordStatus === "Yes"}
                      onChange={handleRadioChange}
                    />{" "}
                    <span className="ml-1">Yes</span>
                    <input
                      type="radio"
                      name="subKeywordStatus"
                      value="No"
                      checked={keywordData.subKeywordStatus === "No"}
                      onChange={handleRadioChange}
                      className="ml-3"
                    />{" "}
                    <span className="ml-1">No</span>
                  </div>
                </div>
              </div>
              {(keywordData.subKeywordStatus === "Yes" ||
                keywordData.unSubKeywordStatus === "Yes" ||
                keywordData.infoKeywordStatus === "Yes") && (
                  <>
                    {keywordData.subKeywordStatus === "Yes" && (
                      <div className="col-md-7">
                        <div className="form-group">
                          <label>Subscription Keyword<span className="text-danger">*</span></label>
                          <input
                            type="text"
                            maxLength={100}
                            className={`form-control ${isSubmitted && keywordData.subKeywordStatus === "Yes" && !keywordData.subKeyword ? 'is-invalid' : ''}`}
                            name="subKeyword"
                            value={keywordData.subKeyword}
                            onChange={handleChange}
                            placeholder="Enter Subscription Keyword"
                          />
                          {isSubmitted && keywordData.subKeywordStatus === "Yes" && !keywordData.subKeyword && (
                            <div className="invalid-feedback">Subscription Keyword is required</div>
                          )}
                        </div>
                        <div className="form-group mt-2">
                          <label>Subscription Arabic Keyword<span className="text-danger">*</span></label>
                          <input
                            type="text"
                            maxLength={100}
                            className={`form-control ${isSubmitted && keywordData.subKeywordStatus === "Yes" && !keywordData.subArabicKeyword ? 'is-invalid' : ''}`}
                            name="subArabicKeyword"
                            value={keywordData.subArabicKeyword}
                            onChange={handleChange}
                            placeholder="Enter Subscription Arabic Keyword"
                          />
                          {isSubmitted && keywordData.subKeywordStatus === "Yes" && !keywordData.subArabicKeyword && (
                            <div className="invalid-feedback">Subscription Arabic Keyword is required</div>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}
            </div>

            <div className="row mt-3">
              <div className="col-md-4">
                <div className="form-group">
                  <label>Un-Sub Keyword<span className="text-danger">*</span></label>
                  <div className="d-flex align-items-center mb-2">
                    <input
                      type="radio"
                      name="unSubKeywordStatus"
                      value="Yes"
                      checked={keywordData.unSubKeywordStatus === "Yes"}
                      onChange={handleRadioChange}
                    />{" "}
                    <span className="ml-1">Yes</span>
                    <input
                      type="radio"
                      name="unSubKeywordStatus"
                      value="No"
                      checked={keywordData.unSubKeywordStatus === "No"}
                      onChange={handleRadioChange}
                      className="ml-3"
                    />{" "}
                    <span className="ml-1">No</span>
                  </div>
                </div>
              </div>
              {(keywordData.subKeywordStatus === "Yes" ||
                keywordData.unSubKeywordStatus === "Yes" ||
                keywordData.infoKeywordStatus === "Yes") && (
                  <>
                    {keywordData.unSubKeywordStatus === "Yes" && (
                      <div className="col-md-7">
                        <div className="form-group">
                          <label>UnSubscription Keyword<span className="text-danger">*</span></label>
                          <input
                            type="text"
                            maxLength={100}
                            className={`form-control ${isSubmitted && keywordData.unSubKeywordStatus === "Yes" && !keywordData.unsubKeyword ? 'is-invalid' : ''}`}
                            name="unsubKeyword"
                            value={keywordData.unsubKeyword}
                            onChange={handleChange}
                            placeholder="Enter UnSubscription Keyword"
                          />
                          {isSubmitted && keywordData.unSubKeywordStatus === "Yes" && !keywordData.unsubKeyword && (
                            <div className="invalid-feedback">UnSubscription Keyword is required</div>
                          )}
                        </div>
                        <div className="form-group mt-2">
                          <label>UnSubscription Arabic Keyword<span className="text-danger">*</span></label>
                          <input
                            type="text"
                            maxLength={100}
                            className={`form-control ${isSubmitted && keywordData.unSubKeywordStatus === "Yes" && !keywordData.unsubArabicKeyword ? 'is-invalid' : ''}`}
                            name="unsubArabicKeyword"
                            value={keywordData.unsubArabicKeyword}
                            onChange={handleChange}
                            placeholder="Enter UnSubscription Arabic Keyword"
                          />
                          {isSubmitted && keywordData.unSubKeywordStatus === "Yes" && !keywordData.unsubArabicKeyword && (
                            <div className="invalid-feedback">UnSubscription Arabic Keyword is required</div>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                )}
            </div>

            <div className="row mt-3">
              <div className="col-md-4">
                <div className="form-group">
                  <label>Info Keyword<span className="text-danger">*</span></label>
                  <div className="d-flex align-items-center mb-2">
                    <input
                      type="radio"
                      name="infoKeywordStatus"
                      value="Yes"
                      checked={keywordData.infoKeywordStatus === "Yes"}
                      onChange={handleRadioChange}
                    />{" "}
                    <span className="ml-1">Yes</span>
                    <input
                      type="radio"
                      name="infoKeywordStatus"
                      value="No"
                      checked={keywordData.infoKeywordStatus === "No"}
                      onChange={handleRadioChange}
                      className="ml-3"
                    />{" "}
                    <span className="ml-1">No</span>
                  </div>
                </div>
              </div>
              {(keywordData.subKeywordStatus === "Yes" ||
                keywordData.unSubKeywordStatus === "Yes" ||
                keywordData.infoKeywordStatus === "Yes") && (
                  <>
                    {keywordData.infoKeywordStatus === "Yes" && (
                      // <div className="row mt-3">
                        <div className="col-md-7">
                          <div className="form-group">
                            <label>Info Keyword<span className="text-danger">*</span></label>
                            <input
                              type="text"
                              maxLength={100}
                              className={`form-control ${isSubmitted && keywordData.infoKeywordStatus === "Yes" && !keywordData.infoKeyword ? 'is-invalid' : ''}`}
                              name="infoKeyword"
                              value={keywordData.infoKeyword}
                              onChange={handleChange}
                              placeholder="Enter Info Keyword"
                            />
                            {isSubmitted && keywordData.infoKeywordStatus === "Yes" && !keywordData.infoKeyword && (
                              <div className="invalid-feedback">Info Keyword is required</div>
                            )}
                          </div>
                          <div className="form-group mt-2">
                            <label>Info Arabic Keyword<span className="text-danger">*</span></label>
                            <input
                              type="text"
                              maxLength={100}
                              className={`form-control ${isSubmitted && keywordData.infoKeywordStatus === "Yes" && !keywordData.infoArabicKeyword ? 'is-invalid' : ''}`}
                              name="infoArabicKeyword"
                              value={keywordData.infoArabicKeyword}
                              onChange={handleChange}
                              placeholder="Enter Info Arabic Keyword"
                            />
                            {isSubmitted && keywordData.infoKeywordStatus === "Yes" && !keywordData.infoArabicKeyword && (
                              <div className="invalid-feedback">Info Arabic Keyword is required</div>
                            )}
                          </div>
                        </div>
                      // </div>
                    )}
                  </>
                )}
            </div>

            <div className="row mt-3">
              <div className="col-md-4">
                <div className="form-group">
                  <label>ShortCode<span className="text-danger">*</span></label>
                  <input
                    type="number"
                    className={`form-control ${isSubmitted && !keywordData.shortCode ? 'is-invalid' : ''}`}
                    name="shortCode"
                    value={keywordData.shortCode}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || (
                        Number.isInteger(Number(value)) &&
                        value >= 0 &&
                        value.toString().length <= 8
                      )) {
                        handleChange(e);
                      }
                    }}
                    onKeyPress={(e) => {
                      if (e.key === '.' || e.key === '-' || e.key === '+' || e.key === 'e') {
                        e.preventDefault();
                      }
                    }}
                    min="0"
                    max="99999999"
                    placeholder="Enter ShortCode"
                    onWheel={(e) => e.target.blur()}
                  />
                  {isSubmitted && !keywordData.shortCode && (
                    <div className="invalid-feedback">ShortCode is required</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-4">
                <div className="form-group">
                  <label>Mo Forward Request<span className="text-danger">*</span></label>
                  <div className="d-flex align-items-center">
                    <input
                      type="radio"
                      name="moForwardStatus"
                      value="Yes"
                      checked={keywordData.moForwardStatus === "Yes"}
                      onChange={handleRadioChange}
                    />{" "}
                    <span className="ml-1">Yes</span>
                    <input
                      type="radio"
                      name="moForwardStatus"
                      value="No"
                      checked={keywordData.moForwardStatus === "No"}
                      onChange={handleRadioChange}
                      className="ml-3"
                    />{" "}
                    <span className="ml-1">No</span>
                  </div>
                </div>
              </div>
              {(keywordData.subKeywordStatus === "Yes" ||
              keywordData.unSubKeywordStatus === "Yes" ||
              keywordData.infoKeywordStatus === "Yes") && (
                <>
                 {keywordData.moForwardStatus === "Yes" && (
              // <div className="row mt-3">
                <div className="col-md-7">
                  <div className="form-group">
                    <label>Mo Forward URL<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      maxLength={100}
                      className={`form-control ${isSubmitted && keywordData.moForwardStatus === "Yes" && !keywordData.moForwardUrl ? 'is-invalid' : ''}`}
                      name="moForwardUrl"
                      value={keywordData.moForwardUrl}
                      onChange={handleChange}
                      placeholder="Enter Mo Forward URL"
                    />
                    {isSubmitted && keywordData.moForwardStatus === "Yes" && !keywordData.moForwardUrl && (
                      <div className="invalid-feedback">Mo Forward URL is required</div>
                    )}
                  </div>
                </div>
              // </div>
            )}
                </>
                )}
            </div>

            {/* Conditional rendering for keyword fields */}
            {/* {(keywordData.subKeywordStatus === "Yes" ||
              keywordData.unSubKeywordStatus === "Yes" ||
              keywordData.infoKeywordStatus === "Yes") && (
                <>
                  <div className="row mt-3"> */}
                    {/* {keywordData.subKeywordStatus === "Yes" && (
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Subscription Keyword<span className="text-danger">*</span></label>
                        <input
                          type="text"
                          maxLength={100}
                          className={`form-control ${isSubmitted && keywordData.subKeywordStatus === "Yes" && !keywordData.subKeyword ? 'is-invalid' : ''}`}
                          name="subKeyword"
                          value={keywordData.subKeyword}
                          onChange={handleChange}
                          placeholder="Enter Subscription Keyword"
                        />
                        {isSubmitted && keywordData.subKeywordStatus === "Yes" && !keywordData.subKeyword && (
                          <div className="invalid-feedback">Subscription Keyword is required</div>
                        )}
                      </div>
                      <div className="form-group mt-2">
                        <label>Subscription Arabic Keyword<span className="text-danger">*</span></label>
                        <input
                          type="text"
                          maxLength={100}
                          className={`form-control ${isSubmitted && keywordData.subKeywordStatus === "Yes" && !keywordData.subArabicKeyword ? 'is-invalid' : ''}`}
                          name="subArabicKeyword"
                          value={keywordData.subArabicKeyword}
                          onChange={handleChange}
                          placeholder="Enter Subscription Arabic Keyword"
                        />
                        {isSubmitted && keywordData.subKeywordStatus === "Yes" && !keywordData.subArabicKeyword && (
                          <div className="invalid-feedback">Subscription Arabic Keyword is required</div>
                        )}
                      </div>
                    </div>
                  )} */}

                    {/* {keywordData.unSubKeywordStatus === "Yes" && (
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>UnSubscription Keyword<span className="text-danger">*</span></label>
                          <input
                            type="text"
                            maxLength={100}
                            className={`form-control ${isSubmitted && keywordData.unSubKeywordStatus === "Yes" && !keywordData.unsubKeyword ? 'is-invalid' : ''}`}
                            name="unsubKeyword"
                            value={keywordData.unsubKeyword}
                            onChange={handleChange}
                            placeholder="Enter UnSubscription Keyword"
                          />
                          {isSubmitted && keywordData.unSubKeywordStatus === "Yes" && !keywordData.unsubKeyword && (
                            <div className="invalid-feedback">UnSubscription Keyword is required</div>
                          )}
                        </div>
                        <div className="form-group mt-2">
                          <label>UnSubscription Arabic Keyword<span className="text-danger">*</span></label>
                          <input
                            type="text"
                            maxLength={100}
                            className={`form-control ${isSubmitted && keywordData.unSubKeywordStatus === "Yes" && !keywordData.unsubArabicKeyword ? 'is-invalid' : ''}`}
                            name="unsubArabicKeyword"
                            value={keywordData.unsubArabicKeyword}
                            onChange={handleChange}
                            placeholder="Enter UnSubscription Arabic Keyword"
                          />
                          {isSubmitted && keywordData.unSubKeywordStatus === "Yes" && !keywordData.unsubArabicKeyword && (
                            <div className="invalid-feedback">UnSubscription Arabic Keyword is required</div>
                          )}
                        </div>
                      </div>
                    )} */}
                  {/* </div> */}

                  {/* {keywordData.infoKeywordStatus === "Yes" && (
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Info Keyword<span className="text-danger">*</span></label>
                          <input
                            type="text"
                            maxLength={100}
                            className={`form-control ${isSubmitted && keywordData.infoKeywordStatus === "Yes" && !keywordData.infoKeyword ? 'is-invalid' : ''}`}
                            name="infoKeyword"
                            value={keywordData.infoKeyword}
                            onChange={handleChange}
                            placeholder="Enter Info Keyword"
                          />
                          {isSubmitted && keywordData.infoKeywordStatus === "Yes" && !keywordData.infoKeyword && (
                            <div className="invalid-feedback">Info Keyword is required</div>
                          )}
                        </div>
                        <div className="form-group mt-2">
                          <label>Info Arabic Keyword<span className="text-danger">*</span></label>
                          <input
                            type="text"
                            maxLength={100}
                            className={`form-control ${isSubmitted && keywordData.infoKeywordStatus === "Yes" && !keywordData.infoArabicKeyword ? 'is-invalid' : ''}`}
                            name="infoArabicKeyword"
                            value={keywordData.infoArabicKeyword}
                            onChange={handleChange}
                            placeholder="Enter Info Arabic Keyword"
                          />
                          {isSubmitted && keywordData.infoKeywordStatus === "Yes" && !keywordData.infoArabicKeyword && (
                            <div className="invalid-feedback">Info Arabic Keyword is required</div>
                          )}
                        </div>
                      </div>
                    </div>
                  )} */}
                {/* </>
              )} */}

            {/* {keywordData.moForwardStatus === "Yes" && (
              <div className="row mt-3">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Mo Forward URL<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      maxLength={100}
                      className={`form-control ${isSubmitted && keywordData.moForwardStatus === "Yes" && !keywordData.moForwardUrl ? 'is-invalid' : ''}`}
                      name="moForwardUrl"
                      value={keywordData.moForwardUrl}
                      onChange={handleChange}
                      placeholder="Enter Mo Forward URL"
                    />
                    {isSubmitted && keywordData.moForwardStatus === "Yes" && !keywordData.moForwardUrl && (
                      <div className="invalid-feedback">Mo Forward URL is required</div>
                    )}
                  </div>
                </div>
              </div>
            )} */}

            <div className="row mt-4">
              <div className="col-md-12 buttons_divs">
                <button
                  type="submit"
                  className="btn btn-primary float-right"
                >
                  Update Keyword Details
                </button>
              </div>
            </div>
          </form>
        </div>
      {/* </div> */}
    </div>
  );
};

export default EditKeyword;


